import React from 'react';
import { useTranslation } from 'react-i18next';
import './idv.styles.scss';
import { Footer } from '../../../components/essentials/footer/footer.component';
import {Getstarted} from '../../../components/essentials/get-started/getstarted.component';
import { OverlapBox } from '../../../components/essentials/overlap-box/overlap-box.component';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import passwordless from '../../../assest/2 - Solutions - Platforms/search-problem.svg';
import ai from '../../../assest/2 - Solutions - Platforms/padlock (1).svg';
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import photoOnPhone from '../../../assest/2 - Solutions - Platforms/EarthId-KYS-01.png';
import phoneImg from '../../../assest/idv/Intro (1).png';
import { OverlapBoxFeature } from '../features-page/features-page.component';
import global from '../../../assest/25 - Age Verification/global coverage.png'
import global1 from '../../../assest/idv/How solution works (1).png'
import global3 from '../../../assest/idv/Benefits.jpg'
//import { FaceId } from '../../../components/homepageComponents/face-id/face-id.component';

import tobacco from '../../../assest/idv/icons (2)/FS.png';
import gamble from '../../../assest/idv/icons (2)/Health.png';
import alcohol from '../../../assest/idv/icons (2)/telco.png';
import cbd from '../../../assest/idv/icons (2)/Travel.png';
import content from '../../../assest/idv/icons (2)/GS.png';
import pharma from '../../../assest/idv/icons (2)/Voting.png';
import diy from '../../../assest/idv/icons (2)/Social.png';
import weapon from '../../../assest/idv/icons (2)/Edu.png';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';


export const IDV = () => {
  const { t } = useTranslation('idv');

  return (
    <div className='solution-platform'>
      <NavBar />
      <HeaderHalf title={t('header.title')} uris={t('header.uris')} />

      <OverlapBox title={t('introBox.title')}>
        <TrackedSection sectionName="IDVPage IntroSection">
          <div className='platform-content'>
            <p className='cards-div-title'>{t('introBox.p1')}</p>
            <div className='cards-div-platform'>
              <MediumCard icon={kysBulletPoint} title={t('introBox.cards.accelerate.title')} desc={t('introBox.cards.accelerate.desc')} />
              <MediumCard icon={passwordless} title={t('introBox.cards.fraud.title')} desc={t('introBox.cards.fraud.desc')} />
              <MediumCard icon={ai} title={t('introBox.cards.compliance.title')} desc={t('introBox.cards.compliance.desc')} />
            </div>
          </div>
        </TrackedSection>
      </OverlapBox>

      <OverlapBoxTechno img={phoneImg} title={t('privacyBox.title')}>
        <TrackedSection sectionName="IDVPage Privacy">
          <p>{t('privacyBox.p1')}</p>
          <p>{t('privacyBox.p2')}</p>
          <p>{t('privacyBox.p3')}</p>
        </TrackedSection>
      </OverlapBoxTechno>

      <SectionRight2
        title={t('howItWorks.title')}
        desc={t('howItWorks.desc')}
        title1={t('howItWorks.steps.step1.title')}
        content1={t('howItWorks.steps.step1.content')}
        title2={t('howItWorks.steps.step2.title')}
        content2={t('howItWorks.steps.step2.content')}
        title3={t('howItWorks.steps.step3.title')}
        content3={t('howItWorks.steps.step3.content')}
        title4={t('howItWorks.steps.step4.title')}
        content4={t('howItWorks.steps.step4.content')}
        title5={t('howItWorks.steps.step5.title')}
        content5={t('howItWorks.steps.step5.content')}
        title6={t('howItWorks.steps.step6.title')}
        content6={t('howItWorks.steps.step6.content')}
        imgPath={global1}
        customClass="feature-box-images"
      />

      <OverlapBoxFeature title={t('featuresTitle')}>
        <TrackedSection sectionName="IDVPage Features">
          <FeaturesBox t={t} />
        </TrackedSection>
      </OverlapBoxFeature>

      <OverlapBoxIndustry title={t('industryUseCases')}>
        <TrackedSection sectionName="IDVPage UseCases">
          <div className='cards-div-industries'>
            <LargeCard img={tobacco} title={t('useCases.financial.title')} desc={t('useCases.financial.desc')} />
            <LargeCard img={gamble} title={t('useCases.healthcare.title')} desc={t('useCases.healthcare.desc')} />
            <LargeCard img={alcohol} title={t('useCases.telecommunication.title')} desc={t('useCases.telecommunication.desc')} />
            <LargeCard img={cbd} title={t('useCases.travel.title')} desc={t('useCases.travel.desc')} />
            <LargeCard img={content} title={t('useCases.government.title')} desc={t('useCases.government.desc')} />
            <LargeCard img={pharma} title={t('useCases.voting.title')} desc={t('useCases.voting.desc')} />
            <LargeCard img={diy} title={t('useCases.welfare.title')} desc={t('useCases.welfare.desc')} />
            <LargeCard img={weapon} title={t('useCases.education.title')} desc={t('useCases.education.desc')} />
          </div>
        </TrackedSection>
      </OverlapBoxIndustry>

      <OverlapBoxFeature title={t('solutionBenefits')}>
        <TrackedSection sectionName="IDVPage SolutionBenefits">
          <EarthidBox t={t} />
        </TrackedSection>
      </OverlapBoxFeature>

      <SectionRight
        title={t('globalCoverage.title')}
        title1={t('globalCoverage.documentSupport')}
        content1={t('globalCoverage.supportDesc')}
        title2={t('globalCoverage.languageSupport')}
        content2={t('globalCoverage.languageDesc')}
        imgPath={global}
      />

      <Getstarted />
      <Footer />
    </div>
  );
};


/* Reusable components remain unchanged besides removing hard-coded text */

const HeaderHalf = ({ title, uris }) => (
  <div className="headerHalf-main-platform">
    <div className="headerHalf-content">
      <p className="headerHalf-title">{title}</p>
      <p className="headerHalf-uris">
        Solutions / <span className="uris-class">{uris}</span>
      </p>
    </div>
  </div>
);

const MediumCard = ({ icon, title, desc }) => (
  <div className="medium-card no-bottom-padding">
    <img src={icon} className="medium-card-icon-platform" alt={`${title} icon`} />
    <p className="medium-card-title">{title}</p>
    <p className="medium-card-desc-platform">{desc}</p>
  </div>
);


const OverlapBoxTechno = ({ img, title, children }) => {
  return (
    <div className='overlap-box-technoo'>
      <img src={img} alt='phone-img' className='techno-img' />
      <div className='techno-content'>
        <p className='techno-title'>{title}</p>
        <div className='rest-para'>{children}</div>
      </div>
    </div>
  );
};


const OverlapBoxIndustry = props => {
  return (
    <div className='overlap-boxx'>
      <p className='box-title'>{props.title}</p>
      {props.children}
    </div>
  );
};

const LargeCard = ({ img, desc, title }) => {
  return (
    <div className='large-card'>
      <img src={img} className='large-card-img' alt='largeCardImg' />
      <p className='large-card-title'>{title}</p>
      <p className='large-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
    </div>
  );
};

const EarthidBox = props => {
  return (
    <div className='kidv-div'>

      <div className='kys-platform-img-top'>
        <img src={photoOnPhone} className='kys-platform-image' alt='EarthID Image' />
      </div>

      <div className='kys-div'>
      <div className='kys-platform-content'>
        <KYSCard icon={kysBulletPoint} title='Frictionless Onboarding'
          desc='Quickly onboard users with AI-powered verification, maintaining robust security standards without delays.'
        />
        <KYSCard icon={kysBulletPoint} title='Global Compliance'
          desc='EarthID adheres to global regulations like GDPR, DPDP, and CCPA, ensuring seamless global access and compliance.'
        />

        <KYSCard icon={kysBulletPoint} title='Advanced Technology'
          desc="Leverage cutting-edge technologies like AI and distributed ledger technology to enhance security and efficiency."
        />
        <KYSCard icon={kysBulletPoint} title='Cost Savings'
          desc='Reusable IDs and KYC reduce time, costs, and friction in onboarding processes.'
        />
      </div>
      <div className='kys-platform-content'>
        

        <KYSCard icon={kysBulletPoint} title='Scalability'
          desc='Adaptable to businesses of any size and across industries, from small enterprises to large-scale operations.'
        />
        <KYSCard icon={kysBulletPoint} title='Improved Customer Conversion'
          desc='Streamline onboarding processes, reducing customer drop-off and boosting conversion rates.'
        />
        <KYSCard icon={kysBulletPoint} title='Enhanced User Experience'
          desc='Deliver a fast, fully automated, user-friendly verification experience, reducing friction for both businesses and users.'
        />
        <KYSCard icon={kysBulletPoint} title='Trust & Security'
          desc='Inspire user confidence with secure, privacy-preserving identity verification solutions.'
        />
      </div>
      </div>
     
     
    </div>


  );
};

const FeaturesBox = () => {
  return (
    <div className='kidv-div'>
<div className='kys-platform-img-top'>
        <img src={global3} className='kys-platform-image' alt='EarthID Image' />
      </div>
      <div className='kys-div'>
      <div className='kys-platform-content'>
        <KYSCard icon={kysBulletPoint} title='Global Reach'
          desc='Supports identity verification of 11000+ documents across more than 220+ countries and territories.'
        />
        <KYSCard icon={kysBulletPoint} title='AI-Powered Verification'
          desc='Proven to deliver speed, convenience, and low friction for your customers resulting in high conversion rates, fraud mitigation, and operational efficiency.'
        />

        <KYSCard icon={kysBulletPoint} title='Anti-Spoofing & Liveness Checks'
          desc='Ensures the identity’s authenticity and confirms users are live, preventing fraud through photo or video submissions.'
        />
        <KYSCard icon={kysBulletPoint} title='Multilingual Support'
          desc='EarthID operates in over 48 languages, ensuring ease of use globally.'
        />
      </div>

      <div className='kys-platform-content'>
        <KYSCard icon={kysBulletPoint} title='Privacy-Preserving Technology'
          desc='Only the necessary information is shared through selective disclosure.'
        />
        <KYSCard icon={kysBulletPoint} title='Reusable ID/KYC'
          desc='Once verified, credentials can be reused for multiple services and platforms.'
        />
        <KYSCard icon={kysBulletPoint} title='No Manual Intervention'
          desc='Our fully automated verification system ensures efficiency and accuracy without human involvement.'
        />
        <KYSCard icon={kysBulletPoint} title='Seamless Integration'
          desc='Easily integrates into existing systems for automated, secure identity checks.'
        />
      </div>
      </div>
    
    </div>
  );
};


export const KYSCard = ({ icon, desc, title }) => {
  return (
    <div className='kys-card'>
      <div ><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
      <div className="key-text-col">
        <p className='kys-card-title'>{title}</p>
        <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    </div>
  );
};

const KDTCard = ({ icon, desc, title }) => {
  return (
    <div className='kys-card'>
      <div ><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
      <div >
        <p className='kys-card-title'>{title}</p>
        <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    </div>
  );
};



const SectionRight = props => {
  return (
    <div className='feature-box-right'>
      <p className='title-feature'>{props.title}</p>
      <div className="display-flex">
        <div className='feature-box-content'>
          <div className='overallcontent'>
          <p className='title1-feature'>{props.title1}</p>
        <p className='content1-feature'>{props.content1}</p>
        <p className='title1-feature'>{props.title2}</p>
        <p className='content1-feature'>{props.content2}</p>
          </div>
        
        </div>
        <div className='feature-box-image'>
          <img src={props.imgPath} />

        </div>
      </div>
    </div>
  );
};

const SectionRight2 = props => {
  return (
    <div className='feature-box-rights'>
      <p className='title-feature'>{props.title}</p>
      <p className='desc1-feature'>{props.desc}</p>
      <div className="kys-div">
        <div className='kys-platform-content'>

            {/* Conditionally render KDTCard if both title1 and content1 exist */}
            {props.title1 && props.content1 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title1}
                desc={props.content1}
              />
            )}

            {/* Conditionally render KDTCard if both title2 and content2 exist */}
            {props.title2 && props.content2 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title2}
                desc={props.content2}
              />
            )}

            {/* Conditionally render KDTCard if both title3 and content3 exist */}
            {props.title3 && props.content3 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title3}
                desc={props.content3}
              />
            )}

            {/* Conditionally render KDTCard if both title4 and content4 exist */}
            {props.title4 && props.content4 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title4}
                desc={props.content4}
              />
            )}

            {/* Conditionally render KDTCard if both title5 and content5 exist */}
            {props.title5 && props.content5 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title5}
                desc={props.content5}
              />
            )}

            {/* Conditionally render KDTCard if both title6 and content6 exist */}
            {props.title6 && props.content6 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title6}
                desc={props.content6}
              />
            )}

            {/* Conditionally render KDTCard if both title7 and content7 exist */}
            {props.title7 && props.content7 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title7}
                desc={props.content7}
              />
            )}

            {/* Conditionally render KDTCard if both title8 and content8 exist */}
            {props.title8 && props.content8 && (
              <KDTCard
                icon={kysBulletPoint}
                title={props.title8}
                desc={props.content8}
              />
            )}

          </div>
          <div className={`kys-platform-imgdt`}>
          <img src={props.imgPath} className='kys-platform-imageedt' alt="feature-img" />
        </div>
        </div>
       
     
    </div>
  );
};
